<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card card-inverse">
        <div class="card-body">
          <form @submit.prevent="startCall()">
            <div class="row">
              <div class="col-md-3">
                <label>Token</label>
                <p>
                  <input
                    type="text"
                    class="form-control"
                    v-model="token"
                    required
                  >
                </p>
              </div>
              <div class="col-md-3">
                <label>{{ __('URL da Central') }}</label>
                <p>
                  <input
                    type="url"
                    class="form-control"
                    v-model="host"
                    required
                  >
                </p>
              </div>
              <div class="col-md-3">
                <label>{{ __('Ramal de Origem') }}</label>
                <p>
                  <input
                    type="text"
                    class="form-control"
                    v-model="caller"
                    required
                  >
                </p>
              </div>
              <div class="col-md-3">
                <label>{{ __('Telefone Destino') }}</label>
                <p>
                  <input
                    type="text"
                    class="form-control"
                    v-model="called"
                    required
                  >
                </p>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 text-center">
                <button
                  type="submit"
                  class="btn btn-box-success"
                >
                  {{ __('Iniciar Chamada') }}
                </button>
              </div>
            </div>
          </form>

          <form @submit.prevent="endCall()">
            <div class="row">
              <div class="col-md-3">
                <label>{{ __('Identificador Chamada') }}</label>
                <p>
                  <input
                    type="text"
                    class="form-control"
                    v-model="idCall"
                  >
                </p>
              </div>
              <div class="col-md-3">
                <label>{{ __('Duração Chamada') }}</label>
                <p>
                  <input
                    type="text"
                    class="form-control"
                    v-model="duration"
                  >
                </p>
              </div>
              <div class="col-md-3">
                <label>{{ __('Status Chamada') }}</label>
                <p>
                  <input
                    type="text"
                    class="form-control"
                    v-model="status"
                  >
                </p>
              </div>
              <div class="col-md-3">
                <label>{{ __('Link Áudio') }}</label>
                <p>
                  <input
                    type="text"
                    class="form-control"
                    v-model="audioLink"
                  >
                </p>
              </div>
              <div class="col-md-3" />
            </div>

            <div class="row">
              <div class="col-md-12 text-center">
                <button
                  type="submit"
                  class="btn btn-box-success"
                >
                  {{ __('Finalizar Chamada') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require('axios');

export default {
  data () {
    return {
      token: '',
      host: '',
      caller: '',
      called: '',
      idCall: '',
      duration: '',
      status: '',
      audioLink: '',
    };
  },

  methods: {
    startCall () {
      this.idCall = '';
      this.duration = '';
      this.status = '';
      this.audioLink = '';

      axios.post(`${this.host}/v1/calls`, {
        caller: this.caller,
        called: this.called,
      }, {
        headers: {
          token_auth: this.token,
        },
      })
        .then((response) => {
          this.idCall = response.data.callId;
          this.status = response.data.state;

          this.checkCall(response.data.callId);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    endCall () {
      if (this.idCall) {
        axios.post(`${this.host}/v1/calls/endcall`, {
          callId: this.idCall,
        }, {
          headers: {
            token_auth: this.token,
          },
        })
          .then((response) => {
            this.status = response.data.state;

            this.checkCall(response.data.callId);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    checkCall (callId) {
      const s = ['calling_origin', 'calling_destination', 'established'];

      axios.get(`${this.host}/v1/calls/${callId}`, {
        headers: {
          token_auth: this.token,
        },
        contentType: 'application/json; charset=utf-8',
      })
        .then((response) => {
          this.status = response.data.state;
          this.duration = response.data.talkingDurationSeconds;

          if (response.data.state == 'finished') {
            this.audioLink = response.data.linkAudio;
          } else if (s.indexOf(response.data.state) >= 0) {
            setTimeout(() => this.checkCall(response.data.callId), 2000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};

</script>
